import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, TextField, Button, Alert } from '@mui/material';

export default function WorkflowTrigger() {
    const [workflowDetails, setWorkflowDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [inputData, setInputData] = useState('{}');
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);
    const [responseStatus, setResponseStatus] = useState(null);
    const { id } = useParams();

    async function fetchWorkflowDetails(id) {
        try {
            setLoading(true);
            const res = await fetch(`/api/workflow/${id}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (res.ok) {
                const json = await res.json();
                setWorkflowDetails(json.workflow);
            } else {
                console.error('Failed to fetch workflow details');
            }
        } catch (err) {
            console.error('Error fetching workflow details:', err);
        } finally {
            setLoading(false);
        }
    }

    async function postTriggerWorkflow() {
        try {
            const res = await fetch(`/api/workflow/trigger/${id}/00000000-0000-0000-0000-000000000000`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: inputData
            });
            if (res.ok) {
                const json = await res.json();
                setResponse(json);
                setResponseStatus('success');
            } else {
                const errorText = await res.text();
                setResponse({ error: errorText });
                setResponseStatus('error');
            }
        } catch (err) {
            console.error('Error triggering workflow:', err);
        }
    }

    useEffect(() => {
        if (id) {
            fetchWorkflowDetails(id);
        }
    }, [id]);

    const updateInputData = (data) => {
        setInputData(data);
        try {
            JSON.parse(data); // Validate JSON
            setError(null);
        } catch (e) {
            setError('Invalid JSON format');
            console.error('Invalid JSON input:', e);
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            {loading && <p>Loading...</p>}
            {!loading && workflowDetails && (
                <Box sx={{ p: 2 }}>
                    <h2>Workflow Trigger: {workflowDetails.name} (v{workflowDetails.version})</h2>
                    <small>{workflowDetails.id}</small>

                    <Box sx={{ mt: 2 }}>
                        <TextField
                            error={!!error}
                            helperText={error || "Enter JSON data to trigger the workflow"}
                            label="Input Data (JSON)"
                            multiline
                            rows={10}
                            fullWidth
                            variant="outlined"
                            placeholder='{"key": "value"}'
                            value={inputData}
                            onChange={(e) => updateInputData(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={postTriggerWorkflow}
                            disabled={!!error}
                        >
                            Trigger Workflow
                        </Button>
                    </Box>
                    {response && (
                        <Box sx={{ mt: 2 }}>
                            <Alert severity={responseStatus === 'success' ? 'success' : 'error'}>
                                {responseStatus === 'success'
                                    ? (
                                        <div>
                                            Workflow triggered successfully:
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                                {JSON.stringify(response, null, 2)}
                                            </pre>
                                        </div>
                                    )
                                    : (
                                        <div>{response.error}</div>
                                    )}
                            </Alert>
                        </Box>
                    )}

                </Box>
            )}
        </Box>

    );
}
